<script setup lang="ts">
</script>

<style>
  :root {
    --color-widget-primary:#fa552d;
    --color-widget-secondary: #000000;
    --color-ticket-badge: #449047;
    --color-ticket-badge--ending: rgb(232, 8, 8);
  }
</style>
<template>
  <div class="min-h-screen bg-slate-50 text-slate-900">
    <router-view />
  </div>
</template>